<template>
    <div>
        <h2 class="post__title text-center bold">第一篇： 咨询前期，心理师为什么要问一堆不着边际的问题？</h2>
        <h3 class="post__meta text-center">by <router-link class="post__author"
          :to="`/home/team`">{{ author }}</router-link>
           	- <time>{{ prettyDate(published) }}</time>
        </h3>
        <h2 class="post__title text-left bold-underlined">志愿者家长S的问题是：</h2>
        <section class="post__body rte">“我觉得我家孩子某些方面的专注力不是很好。比如，当老师只是用说的去表达或者描述一个事情，时间比较长以及没有互动的情况下，他会自己玩自己的,没有认真去听。当然有一部分原因可能是语言不完全明白。但是如果老师有互动或肢体语言较多, 那他会专注一点”。</section>
        
        <h2 class="post__title text-left bold-underlined">心理师询问家庭成员关系，孩子的作息时间，以及幼儿园老师的反馈：</h2>
        <section class="post__body rte">S说家庭成员们关系都不错，孩子作息时间也比较正常。晚上9点半睡觉，早上8点起床，每天基本睡10个半小时。孩子幼儿园老师的反馈是，孩子和其他孩子玩得好，没有行为问题。</section>

        <h2 class="post__title text-left bold-underlined">为什么要询问家庭关系呢？</h2>
        <section class="post__body rte">这是首先要排除孩子没有因为家庭关系紧张而焦虑的问题。当孩子经常焦虑的状况下，专注力会受到影响。</section>

        <h2 class="post__title text-left bold-underlined">为什么要询问孩子的作息时间呢？</h2>
        <section class="post__body rte">孩子如果睡眠不足或质量不好，不仅仅专注力会受到影响，对情绪和行为上都有非常负面的影响。如下图所示，当孩子睡眠有轻微不足的时候，专注力缺乏的问题上升68%，忧郁的问题上升97%，暴力行为上升54%，焦虑的问题上升72%，冲动的问题上升75%</section>

      <div class="row">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/Article1A.png" alt="image"/>
        <section class="mx-auto d-block topbit"><a href="https://www.familymeans.org/articles/2020/03/04/link-between-sleep-and-your-childs-mental-health/">https://www.familymeans.org/articles/2020/03/04/link-between-sleep-and-your-childs-mental-health/</a></section>
        </div>
      </div>

        <h2 class="post__title text-left bold-underlined">为什么要询问孩子在幼儿园的表现呢？</h2>
        <section class="post__body rte">需要先排除孩子没有因为社交困难而产生的紧张，焦虑，自卑等负面情绪，从而影响到他的专注力。</section>

        <router-link @click.native="scrollToTop" :to="`zoom-attention-span-part2`"><h2 class="post__title text-left bold-underlined">下篇预告：如何扩展孩子的专注力 - 给予情感和行为上的支持 （请点击）</h2></router-link>

        <div class="row mx-auto col-md-6">
        <div class="col-md-4">
        <img class="mx-auto d-block" src="@/assets/images/yi_2021.jpg" alt="image"/>
        </div>
        <div class="col-md-6">
          <section class="post__body rte">张艺 – 新西兰注册心理师</section>
          <section class="post__body rte">New Zealand Registered Psychologist</section>
          <section class="post__body rte"><a href="https://www.reachingpotential.co.nz">reachingpotential.co.nz</a></section>
            <img class="col-md-5" src="@/assets/images/yi_weechat.jpg" alt="image"/>
            <section class="post__body rte">微信号：YZNZ2013</section>
        </div>
      </div>
    </div>
</template>

<script>
import { kebabify, prettyDate } from '../helpers'
export default
{
  data() {
    return {
      author: 'Yi Zhang',
      published: '2021-03-13T18:17:00Z'
    }
  },
    methods: {
        kebabify,
        prettyDate,
      scrollToTop() {
        window.scrollTo(0,0);
      }
    }
}
</script>

<style>
@media (min-width: 768px ) {
  .row {
      position: relative;
      padding: 1.25rem 1.25rem 1rem;
  }

  .bottom-align-text {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.list-with-bullets li::before {
  /* padding: 0.25rem 1.25rem 0rem; */
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: black; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */ 
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: 0em; /* Also needed for space (tweak if needed) */
}

.topbit {
  padding-top: 0.5rem;
}

.bottombit {
  padding-bottom: 0.5rem;
}

.imagestyle2
{
  width: 8em;
}

.highlight
{
  background-color: yellow;
  font-size: 23px;
}

.bold-underlined {
  font-weight: bold;
  text-decoration: underline;
}

.bold {
  font-weight: bold;
}
</style>
